const NUMBER = 'NUMBER'
const TEXT = 'TEXT'

const MIN_VALUE = 'MIN_VALUE'
const MAX_VALUE = 'MAX_VALUE'
const REQUIRED = 'REQUIRED'
const REGEX = 'REGEX'

const yupMapper = {
  NUMBER: 'number',
  TEXT: 'string'
}

const yupValidationMapper = {
  MIN_VALUE: 'min',
  MAX_VALUE: 'max',
  REQUIRED: 'required',
  REGEX: 'matches'
}

const fileTypeMapper = {
  'application/pdf': 'PDF',
  'text/csv': 'CSV'
}

const fileAccept = {
  'application/pdf': 'application/pdf',
  'text/csv': 'text/csv'
}

const BATTERYTYPE = {
  ENCHARGE3: 'encharge3',
  ENCHARGE10: 'encharge10',
  ENCHARGE5P: 'encharge5P'
}

export {
  yupMapper,
  yupValidationMapper,
  MIN_VALUE,
  MAX_VALUE,
  REQUIRED,
  REGEX,
  NUMBER,
  TEXT,
  fileTypeMapper,
  fileAccept,
  BATTERYTYPE
}